const login = {
    login: 'Đăng nhập',
    phone: 'Số điện thoại',
    email: 'Email',
    erCode: 'Mã QR',
    phoneNo: 'Số điện thoại',
    sryx: 'Nhập địa chỉ email',
    password: 'Mật khẩu',
    wjmm: 'Quên mật khẩu?',
    srmm: 'Nhập mật khẩu',
    myzh: 'Chưa có tài khoản?',
    ljzc: 'Đăng ký ngay',
    cxsm: 'Làm mới và sử dụng Biking App để quét mã lại',
    xydl: 'Vui lòng đáp ứng trên điện thoại để đăng nhập',
    smewm: 'Trong ứng dụng Biking, nhấn vào biểu tượng thông tin cá nhân, sau đó quét mã QR ở góc phải trên cùng',
    qtfs: 'Đăng nhập bằng cách khác',
    ggsfyz: 'Xác thực danh tính Google',
    bdsj: 'Bạn đã liên kết số điện thoại',
    bdyx: 'Bạn đã liên kết email',
    fsyzm: 'Gửi mã xác thực',
    wcyz: 'Vui lòng hoàn thành quá trình xác minh',
    dlcg: 'Đăng nhập thành công, chào mừng bạn đến với Biking!',
    bktb: 'Vì lý do an ninh, trong vòng 24 giờ sau khi thay đổi cài đặt an ninh tài khoản, bạn sẽ không thể rút tiền',
    fhdl: 'Quay lại trang đăng nhập',
    jx: 'Tiếp tục',
    cxfs: 'Gửi lại',
    gxmm: 'Cập nhật mật khẩu',
    srsjh: 'Nhập số điện thoại',
    wjmm1: 'Quên mật khẩu',
    sryxdz: 'Nhập địa chỉ email',
    srzqyx: 'Nhập đúng địa chỉ email',
    sryzm: 'Nhập mã xác thực',
    czmm: 'Đặt lại mật khẩu',
    sbdyzm: 'Không nhận được mã xác thực?',
    srxmm: 'Nhập mật khẩu mới',
    zczh: 'Đăng ký tài khoản Biking',
    yqm: 'Mã mời (không bắt buộc)',
    sryqm: 'Nhập mã mời',
    zc: 'Đăng ký',
    yyzh: 'Đã có tài khoản?',
    ljdl: 'Đăng nhập ngay',
    fsz: 'Mã xác thực đã được gửi đến',
    next: 'Bước tiếp theo',
    szmm: 'Đặt mật khẩu',
    submit: 'Gửi',
    zccg: 'Đăng ký thành công!'
  }
  const download = {
    title: 'Nền tảng trò chơi và giao dịch tiền điện tử đa dạng',
    subTitle: 'BiKing có thể thực hiện giao dịch tiền điện tử với hơn một trăm loại khác nhau',
    xzbw: 'Tại sao chọn BiKing',
    czzz: 'BiKing hỗ trợ bạn tạo ra, tăng giá và bảo quản tài sản',
    download: 'Tải về trên App Store',
    downloadtf: 'Tải về qua TestFlight',
    cjqxz: 'Tải về Chữ ký Siêu cấp',
    cjq: 'Chữ ký Siêu cấp {index}',
    bdxz: 'Tải về trực tiếp',
    ggpxz: 'Tải về trên Google Play',
    advantageTitle1: 'Hiệu suất hàng đầu · Giao dịch siêu nhanh',
    subTitleSubTitle1: 'Được động viên bởi công nghệ của Sở giao dịch chứng khoán Luân Đôn, độ trễ cực thấp, khớp lệnh siêu nhanh',
    advantageTitle2: 'Bảo vệ tài sản · An ninh tối đa',
    subTitleSubTitle2: 'BiKing tuân thủ tiêu chuẩn CCSS, bảo vệ tài sản và dữ liệu an toàn',
    advantageTitle3: 'Dịch vụ cả ngày',
    subTitleSubTitle3: 'Đảm bảo hệ thống hoạt động bình thường, cung cấp dịch vụ khách hàng cả ngày',
    qhidxq: 'Xem chi tiết về chuyển đổi ID',
    step1: 'Bước 1',
    step2: 'Bước 2',
    step3: 'Bước 3',
    step4: 'Bước 4',
    step5: 'Bước 5',
    step6: 'Bước 6',
    step7: 'Bước 7',
    step8: 'Bước 8',
    step9: 'Bước 9',
    step10: 'Bước 10',
    azBiking: 'Cài đặt BiKing qua App Store',
    dlxz: 'Nếu bạn có ID App không phải ở đại lục, hãy đăng nhập vào App Store để tải về trực tiếp',
    fdlid: 'Chuẩn bị một ID App không phải ở đại lục',
    yxfshq: 'Nếu bạn không có ID App không phải ở đại lục, bạn có thể thử tìm cách nhận ID qua các bước sau',
    qhid: 'Chuyển đổi Apple ID trên App Store',
    dk: '1. Mở',
    ysjtx: 'Ứng dụng App Store, nhấp vào biểu tượng người ở góc trên cùng bên phải của App Store',
    cxsrmm: '2. Nhấp vào Đăng xuất, sau đó nhập lại Apple ID và mật khẩu',
    wfdl: '* Nếu hiển thị "Không thể đăng nhập", có thể là do bạn đã chuyển đổi quá nhanh gần đây, bạn có thể đổi ID hoặc thử lại sau vài giờ. Nếu ID bị khóa, bạn cần xác minh hoặc đổi ID để thử lại',
    azapp: 'Cài đặt ứng dụng',
    storesh: '1. Sau khi đăng nhập thành công, sẽ tự động chuyển đến App Store ở khu vực D tương ứng, tìm kiếm "BiKing", nhấp vào nút "Get" để bắt đầu cài đặt ứng dụng',
    jxxz: 'Tôi có ID Apple không phải ở đại lục, tiếp tục tải về',
    jxxz1: 'Tiếp tục tải về',
    way1: 'Cách 1',
    wayTitle1: 'Tự đăng ký, an toàn và ổn định',
    wayBtn1: 'Xem cách đăng ký',
    way2: 'Cách 2',
    wayTitle2: 'ID tham chiếu từ nền tảng (nhanh chóng và thuận tiện)',
    wayBtn2: 'Xem ID tham chiếu',
    way3: 'Cách 3',
    wayTitle3: 'Hướng dẫn theo quốc gia / vùng lãnh thổ (chuyển đổi tự do)',
    wayBtn3: 'Xem cách mua',
  
    ckzh: 'Tài khoản tham chiếu ID Apple không ở đại lục',
    jgck: 'Dưới đây là danh sách ID ở nước ngoài để tham khảo',
    jjfz: '(Nhấp vào tài khoản hoặc mật khẩu để sao chép trực tiếp)',
    zh: 'Tài khoản',
    mm: 'Mật khẩu',
    xxxl: 'Để tránh rò rỉ thông tin điện thoại di động của bạn',
    dlicloud: 'Hãy chắc chắn rằng bạn không sử dụng ID này để đăng nhập vào iCloud',
    tczh: 'Sau khi sử dụng ID Apple tham chiếu để tải ứng dụng, hãy đăng xuất khỏi tài khoản ngay lập tức',
    cfsy: 'Vui lòng không ràng buộc số điện thoại, nếu không ID sẽ không thể sử dụng lại',
    jrql: 'Quét mã QR để tham gia cuộc trò chuyện',
    lxkf: 'Liên hệ với dịch vụ khách hàng',
  
    zjzc: 'Tự đăng ký ID ở nước ngoài',
    registerStep1: 'Bước 1: Mở trang chủ của appleid',
    registerStep2: 'Bước 2: Xác nhận email',
    registerStep3: 'Bước 3: Đăng xuất khỏi tài khoản App Store',
    registerStep4: 'Bước 4: Đăng nhập vào ID mới trên Store',
    gwzcwz: 'Trong trình duyệt Safari, hãy mở địa chỉ đăng ký trang web chính thức của Apple: ',
    yzdzyx: 'Sau khi điền đầy đủ thông tin, nhấp vào Tiếp tục, sau đó bạn sẽ nhận được một email xác minh ID Apple, cần nhập mã xác minh từ email vào',
    tjfkfs: 'Sau đó, nó sẽ tự động chuyển đến trang quản lý ID Apple (có thể cần thời gian để tải). Sau khi vào trang quản lý, nhấp vào Thanh toán và Giao hàng, và trong trang tiếp theo, nhấp vào Thêm Phương thức Thanh toán',
    mgsfzsc: 'Bây giờ là lúc quan trọng nhất, xác nhận phương thức thanh toán có phải là "Không", nếu là "Không" thì đừng làm gì cả. Quốc gia hoặc khu vực có phải là Mỹ hoặc khu vực bạn muốn đăng ký, nội dung khác có thể nhập bất kỳ. Tuy nhiên, nên điền bằng tiếng Anh, chọn Alaska ở Tỉnh / Thành phố, vì đây là khu vực không chịu thuế, và bạn có thể mua ứng dụng không chịu thuế. Thông tin cá nhân cụ thể có thể được tạo ra qua trang web: Sinh ảo Chứng minh nhân dân Mỹ',
    gxdqxx: 'Sau khi điền xong, nhấp vào Cập nhật để cập nhật thông tin vùng',
    zhxx: '1. Mở App Store, nhấp vào biểu tượng người ở góc phải trên cùng để vào trang tài khoản',
    djwc: '2. Cuộn trang này đến cuối cùng, nhấp vào “Đăng xuất” để đăng xuất khỏi ID Store sau đó nhấp vào “Hoàn thành”',
    jrzhdl: '1. Nhấn vào biểu tượng người ở góc phải trên cùng, sau đó nhấn “Đăng nhập” để vào trang đăng nhập',
    zhmmdl: '2. Nhập ID và mật khẩu, nhấp “Đăng nhập”, để đăng nhập',
    jydlcg: '3. Nhập mã xác minh, sau khi xác minh thành công, bạn sẽ đăng nhập thành công vào Apple ID',
    jysssd: 'Giao dịch mọi lúc mọi nơi',
    smewm: 'Quét mã QR',
    xiazai: 'Tải về',
    huodong: 'Sự kiện',
    title1: 'Nền tảng trò chơi',
    title2: 'và giao dịch tiền điện tử đa dạng của BiKing',
    open: 'Mở trong ứng dụng "BiKing"',
    ggzx: 'Trung tâm thông báo',
    lscb: 'Nạp tiền từ chuỗi khối',
    fbrj: 'Nạp tiền theo pháp lý',
    tgaq: 'Cam kết mang đến cho người dùng dịch vụ giao dịch sản phẩm tài chính mã hóa an toàn hơn',
    wdjmzc: 'Dịch vụ giao dịch sản phẩm tài chính mã hóa ổn định của chúng tôi',
    szhbjy: 'Chúng tôi chuyên nghiệp trong giao dịch tiền điện tử',
    yxhsjh: 'Đăng ký thông qua email / số điện thoại di động',

    appBetaTag: 'BETA chính thức ra mắt',
    appHeroTitle: 'Nâng cấp ứng dụng toàn diện',
    appHeroSubtitle: 'Mở tuyến giao dịch mới cùng Biking',
    tryNow: 'Trải nghiệm ngay',
    downloadBikingApp: 'Tải ứng dụng Biking',
    roadmapStageMeta: '/{total} {phase}',
    roadmapPhase1: 'Giai đoạn 1',
    roadmapPhase2: 'Giai đoạn 2',
    roadmapPhase3: 'Giai đoạn 3',
    roadmapPhase4: 'Giai đoạn 4',
    roadmapPhase5: 'Giai đoạn 5',
    roadmapVisionTitle: 'Tái thiết kế giao diện',
    roadmapVisionDesc: 'Ngôn ngữ thiết kế mới · Tương tác tinh gọn · Trải nghiệm nhập vai',
    roadmapVisionPoint1: 'Ngôn ngữ thiết kế mới',
    roadmapVisionPoint2: 'Tương tác tinh gọn',
    roadmapVisionPoint3: 'Trải nghiệm nhập vai',
    roadmapEngineTitle: 'Nâng cấp engine hiệu năng',
    roadmapEngineDesc: 'Kiến trúc lõi tái cấu trúc · Phản hồi mili giây · Ổn định vượt trội',
    roadmapEnginePoint1: 'Kiến trúc lõi tái cấu trúc',
    roadmapEnginePoint2: 'Phản hồi mili giây',
    roadmapEnginePoint3: 'Ổn định vượt trội',
    roadmapBetaTitle: 'Ra mắt Beta',
    roadmapBetaDesc: 'Hệ thống giao dịch thế hệ mới · Khớp lệnh siêu tốc · Trải nghiệm có thời hạn',
    roadmapBetaPoint1: 'Hệ thống giao dịch thế hệ mới',
    roadmapBetaPoint2: 'Khớp lệnh siêu tốc',
    roadmapBetaPoint3: 'Trải nghiệm có thời hạn',
    roadmapGlobalTitle: 'Nâng cấp toàn diện nền tảng',
    roadmapAiTitle: 'Kỷ nguyên giao dịch AI',
    comingSoon: 'Sắp ra mắt',
    appCopyright: '© 2016-2026 BiKing. Bảo lưu mọi quyền.',
    testFlight: 'Test Flight',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    superSign: 'Super Sign',
    chooseDownload: 'Chọn phương thức tải xuống',
    downloadAddr1: 'Địa chỉ tải xuống 1',
    downloadAddr2: 'Địa chỉ tải xuống 2',
    downloadCancel: 'Hủy',
    apkLocalDownload: 'Tải APK',
    entryBetaTitle: 'Phiên bản Beta đã mở',
    entryBetaSubtitle: 'Trải nghiệm tính năng mới nhất, ưu tiên dùng thử',
    entryBetaTitleFull: 'Phiên bản Beta đã mở — trải nghiệm tính năng mới nhất, ưu tiên dùng thử!',
    entryDownloadNow: 'Tải ngay',
    entryTagNew: 'New',
    entryClose: 'Đóng',
  }
  export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/vi.js